'use strict';

import angular from 'angular';

/**
 * Configuration des routes pour les conventions minières
 */
export default angular.module('observatoireApp')
  .config(['$stateProvider', function($stateProvider) {
    $stateProvider
      .state('main.conventions-minieres', {
        url: '/conventions-minieres',
        templateUrl: 'app/conventions-minieres/conventions-minieres.html',
        controller: 'ConventionsMiniereController'
      })
      .state('main.conventions-minieres-details', {
        url: '/conventions-minieres/:id',
        templateUrl: 'app/conventions-minieres/conventions-minieres-details.html',
        controller: 'ConventionsMiniereDetailsController'
      });
  }]);
